export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 3271,
    source: "https://hut8mining.com/2021/05/13/hut-8-achieves-record-level-revenue-results-in-q1-2021-balance-sheet-grows-134-over-fiscal-2020/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 3824,
    source: "https://hut8mining.com/2021/08/12/hut-8-achieves-second-consecutive-record-level-quarterly-revenue-in-q2-2021/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 4123,
    source: "https://hut8mining.com/2021/08/04/hut-8-mining-provides-production-update-for-july-2021-craig-hallum-initiates-coverage/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 4450,
    source: "https://hut8mining.com/2021/09/02/hut-8-mining-provides-production-update-for-august-2021/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 4724,
    source: "https://hut8mining.com/2021/10/04/hut-8-mining-provides-production-update/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 3271,
    source: "https://hut8mining.com/2021/05/13/hut-8-achieves-record-level-revenue-results-in-q1-2021-balance-sheet-grows-134-over-fiscal-2020/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 3824,
    source: "https://hut8mining.com/2021/08/12/hut-8-achieves-second-consecutive-record-level-quarterly-revenue-in-q2-2021/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 4724,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
